// src/services/api/grower-invites.ts

import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";
import { GrowerInvite } from "../../models/grower-invite";

export const growerInvitesApi = {
  // GET /api/grower-invites?status=pending
  getPending: (): Promise<GrowerInvite[]> =>
    apiProvider
      .getAll("grower-invites", { status: "pending" })
      .then((d: JsonDocument<GrowerInvite[]>) => d.data),

  // POST /api/grower-invites
  create: (email: string): Promise<GrowerInvite> =>
    apiProvider
      .post("grower-invites", { data: { email } })
      .then((d: JsonDocument<GrowerInvite>) => d.data),

  // POST /api/grower-invites/:id/accept  (you already had this)
  accept: (
    id: number,
    token: string,
    password: string,
    name?: string,
  ): Promise<any> =>
    apiProvider.post(`grower-invites/${id}/accept`, {
      data: { token, password, name },
    }),

  // PATCH /api/grower-invites/:id/revoke  (you already had this)
  revoke: (id: number): Promise<any> =>
    apiProvider.patch("grower-invites", id, { action: "revoke" }),
};
